import Cookies from 'js-cookie'
import {mapState,mapActions,mapGetters} from 'vuex';

export default {
    computed: {
        //mapState can be used to quickly get values from the state
        ...mapState('cookiepopup',
            ['showPopup',
                'activeTheme']
        )
    },

    methods: {
        validateCookie(cookie) {
            let cookieType = cookie.type;

            if (cookieType) {
                if(cookieType === 'simple' || cookieType === 'blocking') {
                    return true;
                } else if(cookieType === 'advanced') {
                    //add extra validation for the advanced one
                    return true;
                }
            }

            return false;
        },
    },

    mounted: function () {
        //check for consent cookie
        let cookie = Cookies.get('consent-v2-dismissed');
        if(cookie !== undefined) {
            try {
                cookie = JSON.parse(cookie);

                //check cookie for wrong format
                if(!this.validateCookie(cookie)) {
                    this.$store.dispatch('cookiepopup/getConsentPackage');
                } else {
                    //dispatch version check
                    this.$store.dispatch('cookiepopup/getConsentPackageVersion', cookie.consentPackage.Version);
                }
            } catch (e) {
                //cookie invalid, show popup
                this.$store.dispatch('cookiepopup/getConsentPackage');
            }
        } else {
            //no cookie set, show popup
            this.$store.dispatch('cookiepopup/getConsentPackage');
        }
    }
}